import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import FragmentDataType from "../enums/fragment-data-type";
import Ruleset from "../enums/ruleset";

export default class FieldGoal extends Fragment {
    constructor() {
        super();

        this.code = "FG";

        this.requiredData = [
            {
                name: "isDropKick",
                type: FragmentDataType.Boolean,
                displayName: "Drop Kick",
                title: "Drop Kick",
                subtitle: "Was this field goal a drop kick?",
                defaultValue: false,
                isSkipped: () => this.ruleSetId !== Ruleset.IndoorFootball.code
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const kickType = this.isDropKick ? "Drop Kick" : "Field Goal";
        const message = `${kickType} by ${stringifier.firstInitial(
            summaryContext.kickedBy
        )}`;

        const titleKickType = this.isDropKick ? "Drop Kick FG" : "Field Goal";
        const titleMessage = `${titleKickType} from ${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )}`;

        return new FragmentSummary(message, titleMessage);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.playerInPossession = summaryContext.kickedBy;
    }

    getFragmentTeamId() {
        return this.kickedBy?.teamId;
    }

    excludeRequiredData(rd) {
        if (rd.isSkipped && rd.isSkipped()) {
            return true;
        }
        return false;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            isDropKick: this.isDropKick
        };
    }
}
